import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { ConfigService, SRouterLinkWithHrefDirective } from '@speedy/core';

import { BlockComponent } from '../../../shared/components/block/block.component';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SRouterLinkWithHrefDirective, MatIcon, BlockComponent],
})
export class BannerComponent {
  private readonly configService = inject(ConfigService);

  title = input('');
  description = input('');

  logo = {
    title: this.configService.getLogoAlt(),
    url: this.configService.getLogoImage(),
  };
}
